export default __webpack_public_path__ + "static/media/CeraPro-Bold.eb6ef2d3.woff";